import type { MenuGroup } from '@/components/shared/sidebar/sidebar_menu';
import { useCurrentUserStore } from '@/stores/currentUser';

export const useAgentSidebar = () => {
  const userStore = useCurrentUserStore();

  const menuGroups = (): MenuGroup[] => {
    const isTeammate = userStore.currentAgent.record_type === 'Teammate';
    const isAsyncPipelineReview = userStore.currentAgent.pipeline_review_type === 'async';
    return [
      {
        show: true,
        items: [
          {
            title: 'My Tasks',
            url: '/agent/my_tasks',
            icon: 'check-square',
            show: true,
          },
          {
            title: 'Pipeline Review',
            url: '/agent/pipeline_review',
            icon: 'clipboard',
            show: isTeammate && isAsyncPipelineReview,
          },
          {
            title: 'Referrals',
            url: '/agent/referrals',
            icon: 'users',
            show: isTeammate,
          },
          {
            title: 'University',
            url: '/agent/university',
            icon: 'book-open',
            show: true,
          },
        ],
      },
    ];
  };

  return { menuGroups: menuGroups() };
};
